import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderMenuItemComponent } from '@app/@shared/components/header-menu/header-menu-item/header-menu-item.component';
import { SharedMenuItemComponent } from '@app/@shared/components/shared-menu/shared-menu-item/shared-menu-item.component';
import { FilterByRolePipe } from '@app/@shared/pipes';
import { HeaderMenuComponent, LanguageComponent, SharedMenuComponent } from '@shared/components';
import { SharedModule } from '@shared/shared.module';
import {
  LandingComponent,
  LandingFooterComponent,
  LandingHeaderComponent,
  MainComponent,
  MainFooterComponent,
  MainHeaderComponent,
  SettingsComponent
} from './';

@NgModule({
  declarations: [
    MainHeaderComponent,
    MainFooterComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    LandingComponent,
    MainComponent,
    HeaderMenuComponent,
    SharedMenuComponent,
    LanguageComponent,
    SettingsComponent,
    FilterByRolePipe,
    SharedMenuItemComponent,
    HeaderMenuItemComponent
  ],
  exports: [
    SharedMenuComponent,
    SettingsComponent
  ],
  imports: [
    BrowserModule,
    SharedModule
  ]
})
export class LayoutsModule { }
